import * as Yup from 'yup';
import dayjs from 'dayjs';
import VALIDATION_MESSAGES from 'constants/validationMessages';
import {
  minValue,
  spotRateMaxValue,
  spotNumberMaxValue,
  spotNumberMaxLength,
} from 'constants/fieldsLimits';

export const legacyValidationSchema = Yup.object({
  outletId: Yup.number().required(VALIDATION_MESSAGES.REQUIRED),
  productId: Yup.number().required(VALIDATION_MESSAGES.REQUIRED),
  creativeId: Yup.number().optional(),
  codeId: Yup.number().optional(),
  startDate: Yup.string().required(VALIDATION_MESSAGES.REQUIRED),
  endDate: Yup.string()
    .optional()
    .nullable()
    .test(
      'not earlier than the start date',
      VALIDATION_MESSAGES.DATE,
      (value, context) => {
        if (value && context.parent.startDate) {
          return value >= context.parent.startDate;
        }
        return true;
      }
    ),
  startTime: Yup.string().required(VALIDATION_MESSAGES.REQUIRED),
  endTime: Yup.string()
    .required(VALIDATION_MESSAGES.REQUIRED)
    .test(
      'not earlier than the start time',
      VALIDATION_MESSAGES.TIME,
      (value, context) => {
        if (value && context.parent.startTime) {
          return (
            dayjs(value, 'hh:mm A').isAfter(
              dayjs(context.parent.startTime, 'hh:mm A')
            ) ||
            dayjs(value, 'hh:mm A').isSame(
              dayjs(context.parent.startTime, 'hh:mm A')
            )
          );
        }
        return true;
      }
    ),
  spotsNumber: Yup.number()
    .required(VALIDATION_MESSAGES.REQUIRED)
    .typeError(VALIDATION_MESSAGES.NUMBER)
    .integer(VALIDATION_MESSAGES.INTEGER)
    .min(minValue, VALIDATION_MESSAGES.POSITIVE)
    .max(
      spotNumberMaxValue,
      VALIDATION_MESSAGES.STRING_MAX_LENGTH(spotNumberMaxLength)
    ),
  grossRate: Yup.number()
    .required(VALIDATION_MESSAGES.REQUIRED)
    .typeError(VALIDATION_MESSAGES.NUMBER)
    .min(minValue, VALIDATION_MESSAGES.POSITIVE)
    .max(
      spotRateMaxValue,
      VALIDATION_MESSAGES.FRACTIONAL_NUMBER_MAX_LENGTH('7', '2')
    )
    .test(
      'is valid',
      VALIDATION_MESSAGES.FRACTIONAL_NUMBER_MAX_LENGTH('7', '2'),
      (value: number | undefined) =>
        /^[0-9]{0,7}[.]{0,1}[0-9]{0,2}$/.test(String(value))
    ),
  netRate: Yup.number()
    .required(VALIDATION_MESSAGES.REQUIRED)
    .typeError(VALIDATION_MESSAGES.NUMBER)
    .min(minValue, VALIDATION_MESSAGES.POSITIVE)
    .max(
      spotRateMaxValue,
      VALIDATION_MESSAGES.FRACTIONAL_NUMBER_MAX_LENGTH('7', '2')
    )
    .test(
      'is valid',
      VALIDATION_MESSAGES.FRACTIONAL_NUMBER_MAX_LENGTH('7', '2'),
      (value: number | undefined) =>
        /^[0-9]{0,7}[.]{0,1}[0-9]{0,2}$/.test(String(value))
    ),
});
